import React from "react";
import { EditOutlined } from "@mui/icons-material";
import _ from "lodash";
import { Box, Grid, IconButton } from "@mui/material";
import { getActivityIcon } from "../../services/Activities/activityTypes";
import CircleIcon from "../CircleIcon/CircleIcon";
import ActivityNote from "./ActivityNote";
import CalendlyAssessmentActivity from "../CalendlyAssessments/CalendlyAssessmentActivity";
import { useBackofficeUser } from "../../provider/BackofficeUserProvider";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { Activity } from "../../types/Activity";
import { LogEntry } from "../../types/Activities/ActivityLog";
import doneActivityStyle from "./doneActivityStyle";
import { useDrawer } from "../../provider/DrawerProvider";
import dayjs from "dayjs";

type DoneActivityProps = {
  activity: Activity<string>;
  productClassName: string;
};
const DoneActivity = ({ activity, productClassName }: DoneActivityProps) => {
  const { getUserData } = useBackofficeUser();
  const currentUser = useCurrentUser();
  const { setDrawerState } = useDrawer();

  const dateString = dayjs(activity.dueDate).format("DD.MM.YYYY");
  const timeString = activity.dueTime !== "allDay" ? "um " + activity.dueTime + " Uhr" : "";
  const assignedUser = getUserData(activity.assignedUser);
  const assignedUserName = assignedUser && assignedUser.person.fullname;
  const subject =
    activity.subject +
    " " +
    dateString +
    (timeString ? " " + timeString : "") +
    " | " +
    (assignedUserName || "Nicht zugewiesen");

  const DoneEntry = ({ activity }: { activity: Activity<string> }) => {
    let timedLog: ActivityLogWithDateTimes = _.merge({}, activity.activityLog);
    _.forEach(timedLog, (logEntry, key) => {
      logEntry.logDateTime = key;
    });
    const doneLogEntry = _.head(_.filter(timedLog, "done"));
    if (!doneLogEntry) {
      if (!!activity.doneTime) {
        return (
          <div>
            Erledigt: {dayjs(activity.doneTime).format("DD.MM.YYYY HH:mm")} Uhr | {assignedUserName || "System"}
          </div>
        );
      }
      return null;
    }

    return (
      <div>
        Erledigt: {dayjs(doneLogEntry.logDateTime).format("DD.MM.YYYY HH:mm")} Uhr | {doneLogEntry.updatedBy}
      </div>
    );
  };

  return (
    <Box sx={doneActivityStyle.outerActivityContainer}>
      <Grid container sx={doneActivityStyle.activityContainer}>
        <Grid
          sx={{ ...doneActivityStyle.imageGridItem, display: { xs: "none", sm: "block" } }}>
          <CircleIcon icon={getActivityIcon(productClassName, activity.type)} type={"muiIcon"} />
        </Grid>
        <Grid sx={doneActivityStyle.activityContent}>
          <Grid container wrap={"nowrap"} sx={{
            alignItems: "center"
          }}>
            <Grid sx={doneActivityStyle.headline}>
              {subject}
            </Grid>
            <Grid sx={doneActivityStyle.activityActions}>
              {!currentUser.isExternal && (
                <IconButton onClick={() => setDrawerState({ type: "activity", entityData: activity })} size="large">
                  <EditOutlined />
                </IconButton>
              )}
            </Grid>
          </Grid>
          <DoneEntry activity={activity} />
        </Grid>
      </Grid>
      <ActivityNote noteContent={activity.note} />
      <CalendlyAssessmentActivity activity={activity} />
    </Box>
  );
};
type ActivityLogWithDateTimes = { [key: string]: LogEntry & { logDateTime?: string } };

export default DoneActivity;
